import styled from 'styled-components';
import { FormGrid, FormGroup, HintText } from '../../style';

export const SpacedFormGrid = styled(FormGrid)`
  margin-top: 16px;
`;

export const WideFormGroup = styled(FormGroup)`
  grid-column: span 2;
`;

export const CenteredFormGrid = styled(SpacedFormGrid)`
  align-items: center;
`;

export const StockWarning = styled(HintText)`
  color: #dc2626;
  font-weight: 600;
`;

export const PriceLockBox = styled.div`
  align-self: center;
`;

export const PriceLockText = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #b45309;
`;
